import { viewport } from "./viewport"

interface Settings {
  columns: number
  showStatistics: boolean
}

const defaultSettings: Settings = {
  columns: 122,
  showStatistics: false
}

const LOCALSTORAGE_KEY = 'anni.unravel'

export function getSettings(): Settings {
  const settingsString = localStorage.getItem(LOCALSTORAGE_KEY)
  const settings =
    settingsString !== null
      ? (JSON.parse(settingsString) as Settings)
      : defaultSettings

  storeSettings(settings)

  if (window.location.hash.includes('#')) {
    const hashValue = window.location.hash.split('#')[1]
    if (hashValue === 'auto') {
      console.log('responsive', viewport()[0])
      settings.columns = (viewport()[0] / 7) << 0
      settings.showStatistics = false
    } else {
      const columns = parseInt(hashValue)
      if (!isNaN(columns)) {
        settings.columns = columns
      }
    }
  }

  return settings
}

export function storeSettings(newSettings: Settings): void {
  localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(newSettings))
}

export function changeResolution(amount: number): void {
  const settings = getSettings()
  const newSettings: Settings = {
    ...settings,
    columns: settings.columns + amount
  }
  storeSettings(newSettings)
}

function toggleStatisticsDisplay() {
  const settings = getSettings()
  const newShowStatistics = !settings.showStatistics
  storeSettings({
    ...settings,
    showStatistics: newShowStatistics
  })
}

export let paused = false

function setPaused(_paused: boolean): void {
  paused = _paused
}

document.body.addEventListener('keyup', (e: KeyboardEvent) => {
  switch (e.key) {
    case 'p':
      setPaused(!paused)
      break
    case '+':
      changeResolution(1)
      window.location.reload()
      break
    case '-':
      changeResolution(-1)
      window.location.reload()
      break

    case 'i':
      toggleStatisticsDisplay()
      window.location.reload()
      break
  }
})
